import z from 'zod';
export const EmailSchema = z.string().max(100).regex(/^[\w-+\.]+@([\w-]+\.)+[\w-]{1,63}$/, "Not a valid email format");

// Regex pattern for email validation
export const emailPattern = /^[\w-+\.]+@([\w-]+\.)+[\w-]{1,63}$/;
export const emailPatternMessage = 'Field contains invalid characters. Valid characters: A-Z, a-z, 0-9, ., @';